import apiService from './api';
import type { ApiResponse } from '../types';

/**
 * The current Terms and Conditions version, and whether the user's active
 * organisation has accepted it. One acceptance per organisation, by an admin.
 */
export interface PlatformTermsCurrent {
  /** null when nothing is published — nothing to accept. */
  version: string | null;
  /** YYYY-MM-DD */
  effective_date: string | null;
  summary: string | null;
  hasAccepted: boolean;
  accepted_at: string | null;
  accepted_by_name: string | null;
  /** This user holds the admin role in the active organisation. */
  canAccept: boolean;
}

export function getCurrentTerms(): Promise<ApiResponse<PlatformTermsCurrent>> {
  return apiService.get<PlatformTermsCurrent>('/terms/current');
}

export function acceptTerms(version: string): Promise<ApiResponse<{ version: string; hasAccepted: boolean }>> {
  return apiService.post('/terms/accept', { version });
}
